import { ADD_BOOK_ID } from './../../action-types/bookproperties';

export const STATE_KEY = 'photoBookId';

export const photoBookId = (state = 0, action) => {
  switch (action.type) {
    case ADD_BOOK_ID: {
      return action.bookId;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/photoBookId.js